/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
// 数据源
import { ListStore } from '../../../store';
// 素材
import weChat from '@src/mobile/details/layout/assets/weChat.png';
import friends from '@src/mobile/details/layout/assets/friends.png';
// 端内分享
import { newShare } from '@src/utils/app';
// 组件
import Like from './Like';
import Collect from './Collect';
// 查询参数
import { getQuery, setAppQuery, setAppQueryNoIfengsp } from '@src/utils/url';
import { devPath, LINK_URL } from '@src/constants';
import { Grounds } from '@ifeng-fe/client_grounds';

const UserFun = ({ content }) => {
    // 获取状态数据
    const useListStore = ListStore.useContainer();
    const { listStates } = useListStore;
    const { dramaSeries, positive, currentVideo } = listStates;

    // 微信
    const handleWechat = () => {
        const { title, base62Id, posterUrl, type, summary, id } = dramaSeries;

        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${currentVideo.base62Id}`,
            );
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`,
            );
        }

        const finalTitle =
            positive?.length === 1
                ? dramaSeries.title
                : currentVideo?.title2
                    ? `${dramaSeries.title}|${currentVideo?.title2}`
                    : currentVideo?.title
                        ? currentVideo?.title
                        : dramaSeries.title;

        newShare({
            url: finalUrl,
            title: finalTitle,
            desc: summary,
            thumbnail: posterUrl,
            documentId: `phmovie_${dramaSeries.base62Id}`,
            // 统计
            type: 'phmovie',
            tag: 't85',
            share: 'wxgf',
        });
    };
    // 朋友圈
    const handleFriends = () => {
        const { title, base62Id, posterUrl, type, summary, id } = dramaSeries;

        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${currentVideo.base62Id}`,
            );
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`,
            );
        }
        const finalTitle =
            positive?.length === 1
                ? dramaSeries.title
                : currentVideo?.title2
                    ? `${dramaSeries.title}|${currentVideo?.title2}`
                    : currentVideo?.title
                        ? currentVideo?.title
                        : dramaSeries.title;

        newShare({
            url: finalUrl,
            title: finalTitle,
            desc: summary,
            thumbnail: posterUrl,
            documentId: `phmovie_${dramaSeries.base62Id}`,
            // 统计
            type: 'phmovie',
            tag: 't85',
            share: 'wxcf',
        });
    };

    return (
        <div className={styles.wrap}>
            <Like />
            <Collect />
            <div className={styles.weChat} onClick={handleWechat}>
                <img className={styles.weChatIcon} src={weChat} alt="" />
                <div className={styles.weChatTitle}>微信</div>
            </div>
            <div className={styles.friends} onClick={handleFriends}>
                <img className={styles.friendsIcon} src={friends} alt="" />
                <div className={styles.friendsTitle}>朋友圈</div>
            </div>
        </div>
    );
};

UserFun.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(UserFun);
